import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { AlertModule } from '@shared/alert/alert.module';
import { VersionModalModule } from '@shared/modals/version-modal/version-modal.module';
import { AuthRoutingModule } from './auth-routing.module';

import { LoginComponent } from './login/login.component';

import { FormInputsModule } from '@shared/form-inputs/form-inputs.module';
import { DemoMaterialModule } from '@shared/material-module';
import { NgxSpinnerModule } from 'ngx-spinner';

import { LayoutModule } from '@shared/layout/layout.module';
@NgModule({
    declarations: [LoginComponent],
    imports: [
        CommonModule,
        AuthRoutingModule,
        VersionModalModule,
        ReactiveFormsModule,
        AlertModule,
        DemoMaterialModule,
        FormInputsModule,
        NgxSpinnerModule,
        LayoutModule,
    ],
})
export class AuthModule {}
